import styled from "styled-components";

const Link = styled.a`
  font-size: 15px;
  color: #333;
  display: block;
  text-decoration: none;
  line-height: 18px;
  cursor: pointer;

  &:hover {
    color: #333;
  }
  @media (max-width: 575px) {
    font-size: 13px;
    text-align: center;
  }
`;

export default Link;
